import React, { FC } from 'react'
import { Badge, BadgeProps } from '@mui/material'

const EvtBadge: FC<BadgeProps> = ({ children, ...props }) => {
    return <Badge {...props}>{children}</Badge>
}

export default EvtBadge
